import {
  ACTION_REWARD_CONFIGS,
  type SupportedLoyaltyActionReward,
} from 'loyalty/constants/loyaltyActionRewards'
import { useContext } from 'react'
import LoyaltyActionRewardCTA from './LoyaltyActionRewardCTA'
import LoyaltyActionRewardContext from './LoyaltyActionRewardContext'
import LoyaltyActionRewardsListItemContent, { LoyaltyActionRewardsListItemContentLoadingSkeleton } from './LoyaltyActionRewardsListItemContent'

interface Props {
  reward: SupportedLoyaltyActionReward
  tier: App.LoyaltyTier
  itemPosition: number
}

function LoyaltyActionRewardsListItem({ reward, tier, itemPosition }: Props) {
  const { pendingActionNames } = useContext(LoyaltyActionRewardContext)
  const declaration = ACTION_REWARD_CONFIGS[reward.actionName]
  const { isComplete, title, description } = reward

  if (pendingActionNames.has(reward.actionName)) {
    return <LoyaltyActionRewardsListItemContentLoadingSkeleton />
  }

  const ctaNav = !isComplete ? declaration.ctaNav : undefined
  const showChevron = !!ctaNav

  return <LoyaltyActionRewardCTA
    reward={reward}
    ctaNav={ctaNav}
    itemPosition={itemPosition}
  >
    <LoyaltyActionRewardsListItemContent
      reward={reward}
      tier={tier}
      title={title}
      description={description}
      showChevron={showChevron}
    />
  </LoyaltyActionRewardCTA>
}

export default LoyaltyActionRewardsListItem
